export const addDays = days => {
	var date = new Date(Date.now().valueOf())
	date.setDate(date.getDate() + days)
	return new Date(date)
}
export const addDaysFrom = (date, days) => {
	const daysLater = date.getDate() + days
	return new Date(date.setDate(daysLater))
}
export const today = new Date()
export const updateTime24 = time => (time > 23 ? 23 : time)
export const setTimeIntervals = (range = 24, interval = 30) => {
	var times = []
	var hours = 24 - range
	for (hours; hours < 24; hours++) {
		for (var mins = 0; mins < 60; mins += interval) {
			times = [...times, `${hours < 10 ? '0' : ''}${hours}:${mins === 0 ? 0 : mins < 10 ? '0' : ''}${mins}`]
		}
	}
	return times
}
export const dateFromDMY = (str, limiter = '/') => {
	const [d, m, y] = str.split(limiter)
	return new Date(y, m - 1, d)
}
/* add hours to formatted string ( replace colons with . ) */
export const addHoursToTimeString = (timeString, hours) => {
	const timeSplit = timeString.split(':')
	const hrs = parseInt(timeSplit[0], 10) + hours
	const mins = parseInt(timeSplit[1], 10)
	const result = `${hrs}:${mins > 0 ? mins : mins + '0'}`
	return result
}
/* add hours in miliseconds */
export const hrsToMilliseconds = hours => hours * 3600000
/* create new date object with more hours */
export const addHours = (date, hours) =>
	!isDate(date) ? new Date(date) + hrsToMilliseconds(hours) : new Date(date.getTime() + hrsToMilliseconds(hours))
/* days are same */
export const daysAreSame = (a, b) => a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getYear() === b.getYear()
/* isToday */
export const isToday = date => daysAreSame(date, today)
/* format time  */
export const formatTime = date => {
	var hours = date.getHours()
	var minutes = date.getMinutes()
	var formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`
	return formattedTime
}
/* format date  */
export const formatDate = date => {
	if (!isDate(date)) return ''
	var day = date.getDate()
	var monthIndex = date.getMonth() + 1

	var year = date.getFullYear()
	var formattedDate = `${day}/${monthIndex < 10 ? '0' + monthIndex : monthIndex}/${year}`
	return formattedDate
}
/* is it a date object? */
export const isDate = input => {
	return Object.prototype.toString.call(input) === '[object Date]' && !Number.isNaN(input.getTime())
}
/* remove pesky colons */
export const removeColons = str => str.replace(/[:]/gi, '')
/* get the next inteval along */
export const addInterval = (time, interval = 30) => {
	const times = setTimeIntervals(interval)
	const match = setTimeStrToInterval(time)
	return times.reduce((acumm, val, i, arr) => {
		if (match === val) {
			acumm = arr[i + 1]
		}
		return acumm
	}, '12:30')
}
/* Create a time string based on an interval */
export const setTimeStrToInterval = (str, interval = 30) => {
	const sub = removeColons(str)
	let hours = Number(sub.slice(0, 2))
	let mins = Number(sub.slice(2))

	if (mins > interval) {
		hours += 1
		mins = '00'
	} else if (mins < interval) {
		mins = '30'
	}
	if (hours < 10) {
		hours = `0${hours}`
	}
	const result = `${hours}:${mins}`
	return result
}

// /* return the current time interval based on the time picker intervals */
export const getCurrentTimeInterval = interval => {
	const now = new Date()
	const hh = now.getHours()
	const mm = now.getMinutes()
	const offsetBeforeNow = Math.round(mm / interval) + 1
	const rangeBeforeNow = 24 - hh
	const times = setTimeIntervals(rangeBeforeNow, interval)
	const sliceIndex = offsetBeforeNow >= times.length ? times.length - 1 : offsetBeforeNow
	return times[sliceIndex] || ''
}
export default null
